/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip, tooltipClasses } from "@mui/material";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import AdditionalRecipient from "../../../../components/AdditionalRecipient";
import Loader from "../../../../components/Loader/Index";
import useServiceChecker from "../../../../components/ServiceChecker";
import {
  achivedTaxAccountDetail,
  editDetailsTds,
  taxCompliantAccountDetail,
  tdsDeniedAccount,
  tdsWaitingApproved,
  unachivedTaxAccountDetail,
} from "../../../../redux/features/accounts/taxAccount/taxAccountDetails";
import {
  TaxAddNewLabel,
  TaxRemoveNewLabel,
} from "../../../../redux/features/accounts/taxAccount/taxAccountViewAll";
import {
  beneBankLookUp,
  beneVerifyThisPAN,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { rejectTdsTransaction } from "../../../../redux/features/transactions/taxTransaction/taxTransactionApproval";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import GSTVerification from "../../../Settings/GSTDetails";
import PanVerification from "../../../Settings/PanVerification";
import TaxationTransactionViewAll from "../../../Transactions/TaxationTransactions/TaxationTransactionViewAll";
import OwnerAccountIFSC from "../../OwnerAccount/OwnerAccountIFSC";
import TaxationAccountViewAll from "../TaxationAccountViewAll";

const TaxationAccountDetails = ({ payload, type, tax_account_id }) => {
  const { id } = useParams();
  const labelActionDispatchedRef = useRef(false);
  const [ensureAll] = useServiceChecker();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { tdsTxnViewAllData, tdsTxnViewAllLoading } = useSelector(
    (state) => state.tdsTxnViewAll,
  );

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";
  const [remPan, setRemPan] = useState("");
  const [labels, setLabels] = useState([]);
  const [associateType, setAssociateType] = useState("");
  const [archiveType, setArchiveType] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [showRejectTxnPopup, setRejectTxnPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deniedId, setdeniedId] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [remAccount, setRemAccount] = useState("");
  const [nameArchive, setNameArchive] = useState("");
  const [clickedBtn, setClickedBtn] = useState(null);
  const [activeType, setActiveType] = useState("pan");
  const [showLoader, setShowLoader] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [searchPanText, setSearchPanText] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [showTaxDetails, setShowTaxDetails] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [ViewAccountDetails, setViewAccountDetails] = useState([]);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  // const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  // const [showRejectAllTxnReson, setShowRejectAllTxnReson] = useState(false);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const services = useSelector((state) => state.refreshToken.services);

  const {
    taxCompliantDetailsData,
    tdsDeniedApprovalLoading,
    tdsDeniedApprovalData,
  } = useSelector((state) => state.taxCompliantAccountDetail);

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      editDetailsTds({ id: id, recipient_email: recipientString }),
    );

    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };

  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (response?.payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "CTDSAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const handleApprovalDetails = async (id) => {
    setClickedBtn("approve");
    setShowLoader(true);

    let response;
    UniversalRefreshToast("approvalaccountsRefresh");

    if (
      type === "tax_account_detail_modal" ||
      type === "reimburseacc_details"
    ) {
      response = await dispatch(tdsWaitingApproved(tax_account_id));
    } else {
      response = await dispatch(tdsWaitingApproved(id));
    }

    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BTDSAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.tds_account?.[0]) {
        error_msg = response.payload.errors.tds_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Tax account already approved") {
        const updatedData = taxCompliantDetailsData?.tds_accounts.map(
          (item) => {
            if (
              item.id ===
              (type === "tax_account_detail_modal" ||
                type === "reimburseacc_details")
                ? tax_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        setViewAccountDetails(updatedData);

        response = await dispatch(
          taxCompliantAccountDetail(tax_account_id || id),
        );
        setShowLoader(false);
      } else {
        const updatedData = taxCompliantDetailsData?.tds_accounts.map(
          (item) => {
            if (
              item.id ===
              (type === "tax_account_detail_modal" ||
                type === "reimburseacc_details")
                ? tax_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          },
        );

        setViewAccountDetails(updatedData);
      }
      CommonToast({
        text: `${error_msg}`,
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
    } else {
      const updatedData = taxCompliantDetailsData?.tds_accounts.map((item) => {
        if (
          item.id ===
          (type === "tax_account_detail_modal" ||
            type === "reimburseacc_details")
            ? tax_account_id
            : id
        ) {
          return {
            ...item,
            approval_status:
              item.approval_status === "pending" ? "approved" : "pending",
          };
        }
        return item;
      });
      setViewAccountDetails(updatedData);

      response = await dispatch(
        taxCompliantAccountDetail(tax_account_id || id),
      );
      const successMessage = "Account approved successfully.";
      CommonToast({
        text: `${successMessage}`,
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      if (
        type === "tax_account_detail_modal" ||
        type === "reimburseacc_details"
      ) {
        setTimeout(() => {
          payload?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration.intervalExtraSmall);
      }
      setShowLoader(false);
      if (txn_single_appr === "txn_single_approval") {
        setTimeout(() => {
          navigate(GlobalConfiguration?.lengthCheckNegativeOne);
        }, IntervalConfiguration.intervalExtraLarge);
      }
    }
  };

  const handleModalOpen = (id) => {
    setSelectedChipIndex(null); // reset selection
    setIsEditModalOpen(true);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null); // reset selection
  };

  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }

  const chipsArray = [
    {
      text: "IFSC code",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: false,
      hoverOption: "white",
      bulletPoint: [
        "Please contact an Xpentra administrator to change the IFSC detail",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Name, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval"],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Tax type",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: ["Require approval"],
      hoverOption: "white",
    },
    {
      text: "PAN number, GST",
      selected: selectedChipIndex === TimelineConfiguration.barWidthLarge,
      disabled: false,
      bulletPoint: ["Require approval"],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      hoverOption: "white",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: false,
      bulletPoint: [
        "Require approval",
        "Creates a new account",
        "Archives the old account",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "white",
    },
  ];

  const handleApply = () => {
    // dispatch(resetServices());
    // dispatch(resetEditBeneficiary());
    // dispatch(resetEditBankBeneficiary());

    switch (selectedChipIndex) {
      case 0:
        break;

      case 1:
        // navigate(
        //   `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/contact_details/${id}`,
        //   {
        //     state: previousContactDetails,
        //   },
        // );
        // break;
        setIsEditModalOpen(false);
        toast.info("Feature coming soon!", toast_position);
        break;
      case 2: // Tax type
        // navigate(
        //   `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/categories/${id}`,
        //   {
        //     state: previousContactDetails,
        //   },
        // );
        // break;
        setIsEditModalOpen(false);
        toast.info("Feature coming soon!", toast_position);
        break;
      case 3:
        // dispatch(resetInEdit());
        navigate(
          `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/PAN_details/${id}`,
        );
        return;

      case 4: // Bank account number
        // navigate(
        //   `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/bank_details/${id}`,
        //   {
        //     state: bankDetails,
        //   },
        // );
        // dispatch(resetEditBankBeneficiary());
        // break;
        setIsEditModalOpen(false);
        toast.info("Feature coming soon!", toast_position);
        break;

      default:
        break;
    }
  };

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
    setdeniedId(id);
  };

  const handleClosePopup = () => {
    // setRejectTxnPopup(false);
    setshowPopupReject(false);
    // setShowRejectAllTxnReson(false);
    setDeclineReason("");
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewAccountDetails(updatedAccounts);
  };

  const handleCloseModal = () => {
    // setShowModal(false);
    setUnachivedOpenPop(false);
    setAchivedOpenPop(false);
    setOpenBeneAssociate(false);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleUnarchive = () => {
    setUnachivedOpenPop(true);
    if (taxCompliantDetailsData?.tds_accounts[0]?.archived === "N") {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (taxCompliantDetailsData?.tds_accounts[0]?.archived === "N") {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const handleArchiveButton = async () => {
    let thunkAction = achivedTaxAccountDetail;

    UniversalRefreshToast("archive");
    const archived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      archived_response.type !== "achivedTaxAccountDetail/rejected" ||
      archived_response.payload === "Beneficiary account already archived"
    ) {
      await dispatch(taxCompliantAccountDetail(id));
    }
    handleCloseModal();
    setAchivedOpenPop(false);
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = unachivedTaxAccountDetail;

    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      unarchived_response.type !== "unachivedTaxAccountDetail/rejected" ||
      unarchived_response.payload === "Beneficiary account already pending"
    ) {
      await dispatch(taxCompliantAccountDetail(id));
    }
    handleCloseModal();
  };

  async function fetchData() {
    setLoading(true);
    let response;
    try {
      response = await dispatch(
        taxCompliantAccountDetail(tax_account_id || id),
      );
      // setViewAccountDetails(response);
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
    setLabelDetails(response?.payload?.tds_accounts?.[0]?.labels || []);
    setShowAdditionalRecipient(
      response?.payload?.tds_accounts?.[0]?.recipient_email || [],
    );
    setAdditionalChip(
      response?.payload?.tds_accounts?.[0]?.recipient_email || [],
    );
  }

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    // setShowLoader(true);
    // setTimeout(() => setShowLoader(false), IntervalConfiguration.intervalLarge);
    setshowPopupReject(false);

    const accountInfo = await dispatch(
      taxCompliantAccountDetail(tax_account_id || id),
    );

    if (
      accountInfo?.payload?.tds_accounts?.[0]?.pending_tds_transactions === "Y"
    ) {
      setRejectTxnPopup(true);
    } else {
      handleConfirmDecline(id || tax_account_id, AccountIdData);
    }
  };

  const handleConfirmDecline = async (id, AccountIdData) => {
    // alert("function entered");
    setShowLoader(true);

    UniversalRefreshToast("accountsRefresh");

    if (!tdsDeniedApprovalLoading || tdsDeniedApprovalLoading === null) {
      const data = await dispatch(
        tdsDeniedAccount({ id: id || tax_account_id, AccountIdData }),
      );
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BTDSAccount",
          },
        });
        return;
      }

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });

      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;
        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (data?.payload?.errors?.tds_account) {
          if (
            data?.payload?.errors?.tds_account?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = data?.payload?.errors?.tds_account;
            error_msg = data?.payload?.errors?.tds_account[0];
          } else {
            error_msg = data?.payload?.errors?.tds_account;
            CommonToast({
              text: error_msg[0],
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }
        } else if (data?.payload?.status === false) {
          error_msg = data?.payload?.errors?.category?.[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number[0];
        }

        if (error_msg === "TDS Account account already rejected") {
          const newData = await dispatch(
            taxCompliantAccountDetail({ id: tax_account_id || id }),
          );
          const updatedTaxAccount = {
            ...newData?.payload?.tds?.[0],
            error_msg,
            error: data?.payload?.status === false ? true : false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedTaxAccount || {}),
              };
            }
            return item;
          });
          setShowLoader(false);
          updateAllAccounts(updatedData);
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false ? true : false,
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
          setShowLoader(false);
        }
        setShowLoader(false);
        setDeclineReason("");
        handleClosePopup();
        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.tds_account?.[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.tds_account?.[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === false && data?.payload?.status === false
                  ? true
                  : false,
              message:
                item.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.tds_account[0]
                  : "",
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);

        setDeclineReason("");
        handleClosePopup();

        CommonToast({
          text: `Account rejected successfully`,
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        if (pathName) {
          setTimeout(() => {
            navigate(pathName);
          }, IntervalConfiguration.intervalExtraLarge);
        }
        if (
          type === "tax_account_detail_modal" ||
          type === "reimburseacc_details"
        ) {
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration.intervalExtraSmall);
        }
        setShowLoader(false);
        await dispatch(taxCompliantAccountDetail(tax_account_id || id));
      }
    }
  };

  const handleClose = () => {
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
    }
    setShowLabelsPopup(false);
  };

  const openAssociatedAccountsFound = () => {
    dispatch(
      beneLookUp({ pan_number: taxCompliantDetailsData?.tds_accounts?.pan_no }),
    );
    setRemPan(taxCompliantDetailsData?.tds_accounts?.[0]?.pan_no);
    dispatch(
      beneBankLookUp({
        ifsc: taxCompliantDetailsData?.tds_accounts?.ifsc_code,
        bank_account_no: taxCompliantDetailsData?.tds_accounts?.bank_acc_no,
        bank_account_holder_full_name:
          taxCompliantDetailsData?.tds_accounts?.bank_account_holder_full_name,
      }),
    );

    setOpenBeneAssociate(true);
  };

  const formatTaxType = (type) => {
    const value = type?.toLowerCase();
    if (!value) return "Not assigned";

    const special = ["gst", "pt", "tds"];

    if (special.includes(value)) {
      return value.toUpperCase();
    }

    return value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const toggleContactDetails = () => {
    setShowTaxDetails(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
  };

  const toggleTaxDetails = () => {
    setShowTaxDetails(true);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowTaxDetails(false);
    setAdditionalRecipicent(false);
  };

  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setShowAssignedLabels(false);
    setShowTaxDetails(false);
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      TaxAddNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (TaxAddNewLabel.fulfilled.match(res)) {
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxAddNewLabel.rejected.match(res)) {
      fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoading(false);
    if (TaxAddNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      TaxRemoveNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (TaxRemoveNewLabel.fulfilled.match(res)) {
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (TaxRemoveNewLabel.rejected.match(res)) {
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    setLoading(false);
    if (TaxRemoveNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const asAcc =
    taxCompliantDetailsData?.tds_accounts[0]?.associate_bank === "Y" ||
    taxCompliantDetailsData?.tds_accounts[0]?.associate_pan === "Y";

  const pendingTxn =
    taxCompliantDetailsData?.tds_accounts[0]?.pending_tds_transactions === "Y";

  const buildAlerts = () => [
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isLoading: false,
              isDisabled: false,
              text: "Associated accounts are found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (false) {
                  actionRestricted();
                } else {
                  openAssociatedAccountsFound();
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn &&
        taxCompliantDetailsData?.tds_accounts[0]?.approval_status === "pending"
        ? [
            {
              isLoading: false,
              isDisabled: false,
              text: "Pending transactions found",
              icon: ICONS?.ALERT,
              onClick: () => {
                if (false) {
                  actionRestricted();
                  return;
                } else {
                  const hasAccess =
                    services?.includes("ATDSTransaction") ||
                    services?.includes("Admin");

                  if (!hasAccess) {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "ATDSTransaction" },
                    });
                    return;
                  }

                  setRejectTxnPopup(true);
                  setAssociateType("TaxAccountTxn");
                  // setSearchtype("rejectall");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking pending transactions",
          },
        ]),
  ];

  const handleRejectTxn = async () => {
    setShowLoader(true);
    setshowPopupReject(false);
    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !tdsTxnViewAllLoading &&
      tdsTxnViewAllData?.transactions?.length >
        GlobalConfiguration.lengthCheckZero
        ? tdsTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        rejectTdsTransaction({ id: id2, accountIdData: AccountIdData }),
      );
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      const serviceKey = "ATDSTransaction";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      await dispatch(taxCompliantAccountDetail(tax_account_id || id));
      setShowLoader(false);
    } else if (data?.payload?.status === true) {
      setRejectTxnPopup(false);
      setTimeout(() => {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalSmall);

      if (associateType !== "rejectAccount") {
        await dispatch(taxCompliantAccountDetail(tax_account_id || id));
      }
      if (associateType === "rejectAccount") {
        handleConfirmDecline(id, AccountIdData);
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text_primary)",
          enabledBgColor: "var(--primary_bg)",
        },
      });
      await dispatch(taxCompliantAccountDetail(tax_account_id || id));
    }
    setTimeout(() => {
      setRejectTxnPopup(false);
    }, IntervalConfiguration.intervalMedium);
    if (associateType !== "rejectAccount") {
      setDeclineReason("");
      setAssociateType("");
    }
    setShowLoader(false);
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index, prevIndex]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("TaxAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [tax_account_id, id]);

  useEffect(() => {
    let accountData = [];
    if (taxCompliantDetailsData) {
      accountData = taxCompliantDetailsData?.tds_accounts[0].logs;
    }
    if (
      accountData &&
      taxCompliantDetailsData?.tds_accounts[0].archived === "Y"
    ) {
      setNameArchive(
        accountData
          ?.filter((fil) => fil.action === "Archived")
          ?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))?.[0]
          ?.user_full_name ?? "",
      );
    }
  }, [taxCompliantDetailsData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {openBeneAssociate && (
        <LargePopupRedirect
          headerTitle="Associated accounts"
          headersubtext="The accounts listed below are linked to the selected tax account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setOpenBeneAssociate(false);
            setRemPan("");
            setRemAccount("");
            setRemIFSC("");
            setActiveType("pan");
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          confirmbtnrequired={true}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
          ispanbankRequired={true}
          togglepan={() => {
            setActiveType("pan");
            setRemPan(taxCompliantDetailsData?.tds_accounts?.[0].pan_no);
            setRemAccount("");
            setRemIFSC("");
            setSearchPanText(taxCompliantDetailsData?.tds_accounts?.[0].pan_no);
          }}
          toggleBank={() => {
            setActiveType("bank");
            setRemPan("");
            setRemAccount(
              taxCompliantDetailsData?.tds_accounts?.[0].bank_acc_no,
            );
            setRemIFSC(taxCompliantDetailsData?.tds_accounts?.[0].ifsc_code);
            setSearchPanText(taxCompliantDetailsData?.tds_accounts?.[0].pan_no);
          }}
        >
          <TaxationAccountViewAll
            id={taxCompliantDetailsData?.tds_accounts[0]?.id}
            type={"TaxAcc"}
            remPan={remPan}
            remAccount={remAccount}
            remIFSC={remIFSC}
            activeType={activeType}
            searchPanText={searchPanText}
            currentAccountDetails={taxCompliantDetailsData?.tds_accounts}
            setOpenBeneAssociate={setOpenBeneAssociate}
          />
        </LargePopupRedirect>
      )}

      {showRejectTxnPopup && (
        <LargePopupRedirect
          headerTitle="Associated transactions found"
          headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => {
            setRejectTxnPopup(false);
            setDeclineReason("");
            setShowLoader(false);
            setAchivedOpenPop(false);
          }}
          closeicon={ICONS?.CLOSE}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          bottomHeaderTextNeed={true}
          bottomHeaderText={
            "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
          }
          isbottomSectionneed={true}
          btnText={"Reject all"}
          confirmbtnrequired={true}
          handleFunction={() => {
            if (associateType === "TaxAccountTxn") {
              setshowPopupReject(true);
            } else if (archiveType === "archive") {
              // handleArchiveReject();
            } else {
              handleRejectTxn();
            }
          }}
          isLoaderNeeded={true}
          isLoading={showLoader ? true : false}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          outLineColor={""}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isDisabled={false}
          disabledTextColor={""}
          disabledBgColor={""}
        >
          <TaxationTransactionViewAll
            txnHistoryid={id}
            type={"tax_txnViewAll_popup"}
            flow={"Tax_txnViewAll_popup_reject"}
          />
        </LargePopupRedirect>
      )}

      {showLabelsPopup && (
        <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={taxCompliantDetailsData?.tds_accounts}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            // noteText="The reason must consist of at least 10 characters."
            noteColor="text-secondary"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputIsDisabled={showLoader ? true : false}
            btnOneIsDisabled={showLoader ? true : false}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                handleClosePopup();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (associateType === "TaxAccountTxn") {
                handleRejectTxn();
              } else {
                handleRejectTransactionChecker(deniedId, declineReason);
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.panLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader ? true : false}
            btnTwoIsLoading={showLoader ? true : false}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${taxCompliantDetailsData?.tds_accounts?.[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <OwnerAccountIFSC
              ifsc_code={taxCompliantDetailsData?.tds_accounts?.[0]?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: taxCompliantDetailsData?.tds_accounts?.[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={taxCompliantDetailsData?.tds_accounts?.[0]?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: taxCompliantDetailsData?.tds_accounts?.[0]?.gstin_detail,
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={
              taxCompliantDetailsData?.tds_accounts?.[0]?.gstin_detail
            }
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}
      {unachivedOpenPop && (
        <div
          onClick={() => setUnachivedOpenPop(false)}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
        >
          <SmallPopup
            headerTitle={"Unarchive account"}
            subtext="Are you sure you want to unarchive this account?"
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={handleCloseModal}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Unarchive"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleUnArchiveButton}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
            noteText="This account will become active."
          />
        </div>
      )}
      {achivedOpenPop && (
        <div
          onClick={() => setAchivedOpenPop(false)}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
        >
          <div>
            <SmallPopup
              headerTitle={"Archive account"}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Are you sure you want to archive this account?"
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={handleCloseModal}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Archive"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleArchiveButton}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              noteText="This account will become inactive."
            />
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={handleModalClose}
            headerTitle="Select the option you would like to edit:"
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={
              selectedChipIndex === null ||
              selectedChipIndex === GlobalConfiguration.lengthCheckZero
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div
        className={`${type === "tax_account_detail_modal" ? "h-height-full" : "h-screen"} flex flex-col overflow-hidden`}
      >
        <div
          className={`h-[var(--mobile-create-header)] Qsmd:h-navbar-breadcrumb-height bg-primary-nav w-width-full ${type === "tax_account_detail_modal" ? "hidden" : "flex"}`}
        ></div>

        <div
          className={`bene_detail_heder_containerm shadow-box-shadow-bottom ${type === "tax_account_detail_modal" ? "hidden" : "Qmd:hidden"}`}
        >
          <div className="allBenedetailheadertext">
            <div
              className="allBenedetailheaderarrow"
              onClick={() => navigate(-1)}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color="var(--text-primary)"
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
              />
            </div>
            <div className="allBenedetailheadertextm">
              <div className="text-base text-text-primary font-normal font-sans">
                {"Tax"}
              </div>
              <div className="text-xs text-text-secondary font-normal font-sans">
                Accounts details
              </div>
            </div>
          </div>{" "}
        </div>

        <div className="main-div flex flex-col flex-1 overflow-y-auto">
          {loading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : (
            <div>
              <div className="bg-primary-nav">
                <div className="w-full max-w-screen-Qlg mx-auto Qsmd:px-padding-md Qlg:px-padding-base">
                  <div>
                    {/* 1st row */}
                    {taxCompliantDetailsData?.tds_accounts.map((account) => (
                      <div
                        key={account.id}
                        className="flex border-b border-solid border-primary-bg justify-between mx-margin-md Qsmd:mx-margin-base"
                      >
                        <div className="flex flex-col Qmd:flex-row w-full  ">
                          <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                            <div className="flex flex-col Qmd:border-r border-solid border-primary-bg pl-padding-sm pr-padding-md">
                              <TitleSubtitlePair
                                title={account.name
                                  ?.toLowerCase()
                                  ?.split(" ")
                                  ?.map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1),
                                  )
                                  ?.join(" ")}
                                titleColor="text-primary "
                                subtitle={
                                  account?.name?.trim() ===
                                  account?.pan_legal_name?.trim()
                                    ? "Account name - Using legal name"
                                    : "Account name"
                                }
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                              />
                            </div>
                          </div>

                          {/* {ViewAccountDetails?.map((account) => ( */}
                          <div
                            // key={account.id}
                            className="w-full Qmd:w-right-half py-padding-md"
                          >
                            <div className="flex flex-col items-start pl-padding-sm Qmd:pl-padding-md">
                              <TitleSubtitlePair
                                title={
                                  account?.approval_status === "error"
                                    ? "Pending"
                                    : account?.approval_status
                                        ?.toLowerCase()
                                        ?.split(" ")
                                        ?.map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1),
                                        )
                                        ?.join(" ")
                                }
                                titleColor={`${
                                  account.approval_status === "pending" ||
                                  account.approval_status === "error"
                                    ? "pending"
                                    : account.approval_status === "approved"
                                      ? "awaiting"
                                      : account.approval_status === "rejected"
                                        ? "failed"
                                        : account.approval_status === "blocked"
                                          ? "failed"
                                          : account.approval_status ===
                                              "archived"
                                            ? "abandoned"
                                            : ""
                                }`}
                                subtitle="Account status"
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                              />
                            </div>
                          </div>
                          {/*  ))} */}
                        </div>
                        <div className="associated-account-transaction-history-block Qmd:flex flex-row bg-primary-nav-act hidden">
                          <TopNavSmallButton
                            btnText={
                              <>
                                Associated <br /> accounts
                              </>
                            }
                            handleFunction={() => {
                              if (type === "tax_account_detail_modal") {
                                actionRestricted();
                                return;
                              }
                              openAssociatedAccountsFound();
                            }}
                            icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            disabledBgColor={"var(--primary-nav-act)"}
                            disabledTextColor={"var(--text-primary)"}
                            isDisabled={type === "tax_account_detail_modal"}
                            hoverOption="white"
                          />

                          <div className="py-padding-button-l flex">
                            <div className="flex-grow border-r border-solid border-primary-bg"></div>
                          </div>

                          <TopNavSmallButton
                            btnText={
                              <>
                                Transaction <br /> history
                              </>
                            }
                            handleFunction={() => {
                              if (type === "tax_account_detail_modal") {
                                actionRestricted();
                                return;
                              }
                              CommonToast({
                                text: "Feature coming soon",
                                icon: ICONS?.INFO,
                                variant: "var(--coming-soon)",
                                buttonNeeded: false,
                              });
                              // openTransactionHistory();
                            }}
                            icon={ICONS?.TRANSACTION_HISTORY}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            disabledBgColor={"var(--primary-nav-act)"}
                            disabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={type === "tax_account_detail_modal"}
                          />
                        </div>
                      </div>
                    ))}

                    {/* 2nd row */}
                    {taxCompliantDetailsData?.tds_accounts.map((account) => (
                      <div
                        // key={account.id}
                        className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between  mx-margin-md Qsmd:mx-margin-base"
                      >
                        <div className="flex flex-col Qmd:flex-row w-full ">
                          <div className="py-padding-md pl-padding-sm w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                            <TitleSubtitlePair
                              title={formatAccountNumber(account.bank_acc_no)}
                              titleColor="text-primary"
                              subtitle="  Account number"
                              alignRight={false}
                              hoverOption="white"
                              isBold={false}
                              variant="md"
                            />
                          </div>
                          <div className="py-padding-md w-full Qmd:w-right-half">
                            <div className="flex flex-col items-start pl-padding-sm Qmd:pl-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg">
                              <TitleSubtitlePair
                                title={account.bank_account_holder_full_name}
                                titleColor="text-primary"
                                subtitle=" Bank account holder name"
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="settings Qmd:flex flex-row hidden justify-end bg-primary-nav-act">
                          <>
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Edit <br /> account
                                </>
                              }
                              handleFunction={() => {
                                const status =
                                  taxCompliantDetailsData?.tds_accounts?.[0]
                                    ?.approval_status;

                                if (["archived", "blocked"].includes(status))
                                  return;

                                if (type === "tax_account_detail_modal") {
                                  actionRestricted();
                                  return;
                                }

                                if (
                                  services?.some(
                                    (service) =>
                                      service === "CTDSAccount" ||
                                      service === "Admin",
                                  )
                                ) {
                                  handleModalOpen(id);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "CTDSAccount",
                                    },
                                  });
                                }
                              }}
                              icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                              isDisabled={
                                type === "tax_account_detail_modal" ||
                                ["archived", "blocked"].includes(
                                  taxCompliantDetailsData?.tds_accounts?.[0]
                                    ?.approval_status,
                                ) ||
                                !services?.some(
                                  (service) =>
                                    service === "CTDSAccount" ||
                                    service === "Admin",
                                )
                              }
                            />
                          </>
                          <div className="py-padding-button-l flex">
                            <div className="flex-grow border-r border-solid border-primary-bg"></div>
                          </div>

                          <TopNavSmallButton
                            btnText={
                              taxCompliantDetailsData?.tds_accounts?.[0]
                                ?.approval_status === "archived" ? (
                                <>
                                  Unarchive <br /> account
                                </>
                              ) : (
                                <>
                                  Archive <br /> account
                                </>
                              )
                            }
                            handleFunction={() => {
                              const status =
                                taxCompliantDetailsData?.tds_accounts?.[0]
                                  ?.approval_status;

                              const hasPermission = services?.some(
                                (service) =>
                                  service === "ArchiveTDSAccount" ||
                                  service === "Admin",
                              );

                              if (type === "tax_account_detail_modal") {
                                actionRestricted();
                                return;
                              }

                              if (status === "blocked") return;

                              if (hasPermission) {
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "ArchiveTDSAccount",
                                  },
                                });
                              }
                            }}
                            icon={
                              taxCompliantDetailsData?.tds_accounts?.[0]
                                ?.approval_status === "archived"
                                ? ICONS?.UNARCHIVE
                                : ICONS?.ARCHIVE
                            }
                            enabledBgColor="var(--primary-nav-act)"
                            enabledTextColor="var(--text-primary)"
                            hoverOption="white"
                            isDisabled={
                              type === "tax_account_detail_modal" ||
                              taxCompliantDetailsData?.tds_accounts?.[0]
                                ?.approval_status === "blocked" ||
                              !services?.some(
                                (service) => service === "ArchiveTDSAccount",
                              )
                            }
                          />
                        </div>
                      </div>
                    ))}

                    {/* 3rd row */}

                    {taxCompliantDetailsData?.tds_accounts.map((account) => (
                      <div
                        // key={account.id}
                        className="bene-account-holder-details flex justify-between flex-col Qmd:flex-row "
                      >
                        <div className="flex flex-col Qmd:flex-row w-full px-padding-md Qsmd:px-padding-base">
                          <div className="py-padding-sm flex flex-row justify-between items-center w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                            <TitleSubtitlePair
                              title={account?.ifsc_code}
                              titleColor="text-primary "
                              isDisabled={type === "tax_account_detail_modal"}
                              subtitle="IFSC code"
                              alignRight={false}
                              hoverOption="white"
                              isBold={false}
                              variant="md"
                              showArrow="true"
                              onClick={() => {
                                if (
                                  services?.find(
                                    (service) =>
                                      service === "VIFSC" ||
                                      service === "Admin",
                                  ) !== undefined &&
                                  account.ifsc_code
                                ) {
                                  if (type === "tax_account_detail_modal") {
                                    actionRestricted();
                                  } else {
                                    setIfscShowPopup(true);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VIFSC",
                                    },
                                  });
                                }
                              }}
                            />

                            <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md my-margin-md px-padding-sm py-padding-button-s  mr-margin-md">
                              <CommonBankLogo
                                ifsc={account?.ifsc_code}
                                variant="big"
                              />
                            </div>
                          </div>

                          <div className="py-padding-md w-full Qmd:w-right-half">
                            <div className="flex flex-col items-start pl-padding-sm Qmd:pl-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg">
                              <TitleSubtitlePair
                                title={formatTaxType(account?.category)}
                                titleColor="text-primary"
                                subtitle="Tax type"
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                              />
                            </div>
                          </div>
                        </div>
                        <div className={`flex Qmd:h-auto`}>
                          <div className={`w-full`}>
                            <div className={`pay-bene w-full flex justify-end`}>
                              {taxCompliantDetailsData?.tds_accounts?.map(
                                (account) => (
                                  <>
                                    {showLoader ? (
                                      <>
                                        <div className="Qsmd:w-max-button-width-for-approval-animation w-width-full flex">
                                          <div
                                            className={`w-width-full flex justify-center items-center ${
                                              clickedBtn === "reject"
                                                ? "bg-negative-act"
                                                : "bg-positive-act"
                                            } py-padding-lg`}
                                          >
                                            <Loader
                                              height="var(--icon-lg)"
                                              width="var(--icon-lg)"
                                            />
                                          </div>
                                        </div>
                                      </>
                                    ) : account?.approval_status ===
                                      "approved" ? (
                                      <>
                                        <TopNavLargeButton
                                          hoverOption={"black"}
                                          // isDisabled={
                                          //   !services?.find(
                                          //     (service) =>
                                          //       service === "CBeneficiaryTxn" ||
                                          //       service === "Admin",
                                          //   )
                                          // }
                                          btnText={
                                            <>
                                              Pay <br /> now
                                            </>
                                          }
                                          btnType={"button"}
                                          handleFunction={() => {
                                            if (
                                              type ===
                                              "tax_account_detail_modal"
                                            ) {
                                              actionRestricted();
                                              return;
                                            }
                                            if (
                                              services?.find(
                                                (service) =>
                                                  service === "BUAccount" ||
                                                  service === "Admin",
                                              ) !== undefined &&
                                              account?.approval_status ===
                                                "approved"
                                            ) {
                                              CommonToast({
                                                text: "Feature coming soon",
                                                icon: ICONS?.INFO,
                                                variant: "var(--coming-soon)",
                                                buttonNeeded: false,
                                              });
                                              // createTransaction();
                                              // sessionStorage.removeItem(
                                              //   "recreate_ben",
                                              // );
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "BUAccount",
                                                  },
                                                },
                                              );
                                            }
                                          }}
                                          // icon={transactionImage}
                                          icon={ICONS?.PAY_WITH_CIRCLE}
                                          enabledBgColor={"var(--positive-act)"}
                                          enabledTextColor={
                                            "var(--text-primary)"
                                          }
                                          isDisabled={
                                            type ===
                                              "tax_account_detail_modal" ||
                                            !services?.some(
                                              (service) =>
                                                service === "BUAccount",
                                            )
                                          }
                                          fullWidthRequired={isMobile}
                                        />
                                      </>
                                    ) : account?.approval_status ===
                                        "rejected" ||
                                      account?.approval_status === "blocked" ||
                                      account?.approval_status ===
                                        "archived" ? (
                                      <div className="Qsmd:invisible hidden Qsmd:block">
                                        <TopNavLargeButton
                                          hoverOption={"black"}
                                          btnText={
                                            <>
                                              Pay <br /> now
                                            </>
                                          }
                                          btnType={"button"}
                                          handleFunction={() => {}}
                                          // icon={transactionImage}
                                          icon={ICONS?.PAY_WITH_CIRCLE}
                                          enabledBgColor={"var(--positive-act)"}
                                          enabledTextColor={
                                            "var(--text-primary)"
                                          }
                                          fullWidthRequired={isMobile}
                                        />
                                      </div>
                                    ) : account?.approval_status ===
                                        "rejected" &&
                                      account?.error_msg?.length > 0 ? (
                                      <div
                                        key={account.id}
                                        className={`pay-bene-box2 flex justify-end  ${
                                          account?.approval_status ===
                                            "approved" &&
                                          services?.find(
                                            (service) =>
                                              service === "CBeneficiaryTxn" ||
                                              service === "Admin",
                                          ) !== undefined &&
                                          taxCompliantDetailsData.category
                                            .length > 0
                                            ? "bg-Button-green hover:opacity-dark-opacity"
                                            : account?.approval_status ===
                                                "approved"
                                              ? "bg-Button-green"
                                              : ""
                                        }`}
                                      >
                                        <div className="flex flex-row gap-x-gap-sm h-full w-full bg-failed-to-take-action p-padding-sm">
                                          <div className="flex place-items-center">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              alt="Error with white outline circle"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                            <span className="font-semibold font-sans text-xs text-text-primary">
                                              Failed to take action
                                            </span>
                                            <Tooltip
                                              componentsProps={{
                                                popper: {
                                                  sx: {
                                                    [`& .${tooltipClasses.tooltip}`]:
                                                      {
                                                        backgroundColor: (
                                                          theme,
                                                        ) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                    [`& .${tooltipClasses.arrow}`]:
                                                      {
                                                        color: (theme) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                  },
                                                },
                                              }}
                                              title={account?.error_msg}
                                              arrow
                                              placement="bottom"
                                              PopperProps={{
                                                style: {
                                                  maxWidth: "none",
                                                },
                                              }}
                                            >
                                              <span className="font-sans text-font-xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </Tooltip>
                                          </div>
                                        </div>
                                      </div>
                                    ) : account.approval_status === "pending" &&
                                      account.error_msg?.length > 0 ? (
                                      <div
                                        key={account.id}
                                        className={`pay-bene-box2 flex justify-end ${
                                          account?.approval_status ===
                                            "approved" &&
                                          services?.find(
                                            (service) =>
                                              service === "CBeneficiaryTxn" ||
                                              service === "Admin",
                                          ) !== undefined &&
                                          taxCompliantDetailsData.category
                                            .length > 0
                                            ? "bg-Button-green hover:opacity-dark-opacity"
                                            : account?.approval_status ===
                                                "approved"
                                              ? "bg-Button-green"
                                              : ""
                                        }`}
                                      >
                                        <div className="flex flex-row h-full w-full bg-failed-to-take-action p-padding-sm">
                                          <div className="flex place-items-center w-1/6">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              alt="Error with white outline circle"
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-gap-xs w-5/6 ml-margin-sm">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <Tooltip
                                              componentsProps={{
                                                popper: {
                                                  sx: {
                                                    [`& .${tooltipClasses.tooltip}`]:
                                                      {
                                                        backgroundColor: (
                                                          theme,
                                                        ) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                    [`& .${tooltipClasses.arrow}`]:
                                                      {
                                                        color: (theme) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                  },
                                                },
                                              }}
                                              title={account?.error_msg}
                                              arrow
                                              placement="bottom"
                                              PopperProps={{
                                                style: {
                                                  maxWidth: "none",
                                                },
                                              }}
                                            >
                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </Tooltip>
                                          </div>
                                        </div>
                                      </div>
                                    ) : account.approval_status === "error" ? (
                                      <div className="flex flex-row h-full bg-failed-to-take-action p-padding-sm">
                                        <div className="flex place-items-center w-1/6">
                                          <img
                                            src={
                                              ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                            }
                                            alt="Error with white outline circle"
                                            className="w-icon-lg h-icon-lg mr-margin-button-m"
                                          />
                                        </div>
                                        <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                          <span className="font-semibold font-sans text-sm text-text-primary">
                                            Failed to take action
                                          </span>
                                          <div>
                                            <Tooltip
                                              componentsProps={{
                                                popper: {
                                                  sx: {
                                                    [`& .${tooltipClasses.tooltip}`]:
                                                      {
                                                        backgroundColor: (
                                                          theme,
                                                        ) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                    [`& .${tooltipClasses.arrow}`]:
                                                      {
                                                        color: (theme) =>
                                                          theme.palette.common
                                                            .black,
                                                      },
                                                  },
                                                },
                                              }}
                                              title={
                                                account?.error_msg
                                                  ? account?.error_msg
                                                  : tdsDeniedApprovalData
                                                      ?.errors?.tds_account?.[0]
                                              }
                                              arrow
                                              placement="bottom"
                                              PopperProps={{
                                                style: {
                                                  maxWidth: "none",
                                                },
                                              }}
                                            >
                                              <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font-xs text-text-primary opacity-base-opacity">
                                                {account?.error_msg
                                                  ? account?.error_msg
                                                  : tdsDeniedApprovalData
                                                      ?.errors
                                                      ?.tds_account?.[0]}
                                                .
                                              </p>
                                            </Tooltip>
                                          </div>
                                        </div>
                                      </div>
                                    ) : account.approval_status ===
                                      "pending" ? (
                                      <div
                                        key={account.id}
                                        className={`pay-bene-box2 flex justify-end w-full ${
                                          account?.approval_status ===
                                            "approved" &&
                                          services?.find(
                                            (service) =>
                                              service === "CBeneficiaryTxn" ||
                                              service === "Admin",
                                          ) !== undefined &&
                                          taxCompliantDetailsData.category
                                            .length > 0
                                            ? "bg-Button-green hover:opacity-dark-opacity"
                                            : account?.approval_status ===
                                                "approved"
                                              ? "bg-Button-green"
                                              : ""
                                        }`}
                                      >
                                        <TopNavSmallButton
                                          btnText={
                                            <>
                                              Reject <br /> account
                                            </>
                                          }
                                          handleFunction={() => {
                                            if (
                                              services?.find(
                                                (service) =>
                                                  service === "BTDSAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                            ) {
                                              setAssociateType("rejectAccount");
                                              handleDeclinedDetials(
                                                account.id || tax_account_id,
                                              );
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "BTDSAccount",
                                                  },
                                                },
                                              );
                                            }
                                          }}
                                          icon={ICONS?.REJECT_CIRCLE_RED_ICON}
                                          enabledBgColor={"var(--negative-act)"}
                                          isDisabled={
                                            !services?.find(
                                              (service) =>
                                                service === "BTDSAccount" ||
                                                service === "Admin",
                                            )
                                          }
                                          enabledTextColor={
                                            "var(--text-primary"
                                          }
                                          hoverOption="black"
                                          fullWidthRequired={isMobile}
                                        />
                                        <TopNavSmallButton
                                          btnText={
                                            <>
                                              Approve <br /> account
                                            </>
                                          }
                                          isDisabled={
                                            !services?.find(
                                              (service) =>
                                                service === "BTDSAccount" ||
                                                service === "Admin",
                                            )
                                          }
                                          handleFunction={() => {
                                            if (
                                              services?.find(
                                                (service) =>
                                                  service === "BTDSAccount" ||
                                                  service === "Admin",
                                              ) !== undefined
                                            ) {
                                              handleApprovalDetails(account.id);
                                            } else {
                                              navigate(
                                                "/feature_not_assigned",
                                                {
                                                  state: {
                                                    unavailableService:
                                                      "BTDSAccount",
                                                  },
                                                },
                                              );
                                            }
                                          }}
                                          icon={
                                            ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK
                                          }
                                          enabledBgColor={"var(--positive-act)"}
                                          enabledTextColor={
                                            "var(--text-primary"
                                          }
                                          hoverOption="black"
                                          fullWidthRequired={isMobile}
                                        />
                                      </div>
                                    ) : null}
                                  </>
                                ),
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="bene_quickaction_containerm block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div className="bg-primary-nav-act">
                    <div className="associated-account-transaction-history-block Qmd:hidden flex flex-row border-b border-solid border-primary-bg">
                      <TopNavSmallButton
                        btnText={
                          <>
                            Associated <br /> accounts{" "}
                          </>
                        }
                        handleFunction={() => {
                          if (type === "tax_account_detail_modal") {
                            actionRestricted();
                            return;
                          }
                          openAssociatedAccountsFound();
                        }}
                        icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary)"}
                        disabledBgColor={"var(--primary-nav-act)"}
                        disabledTextColor={"var(--text-primary)"}
                        isDisabled={type === "tax_account_detail_modal"}
                        hoverOption="white"
                        fullWidthRequired={true}
                      />

                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Transaction <br /> history
                          </>
                        }
                        handleFunction={() => {
                          if (type === "tax_account_detail_modal") {
                            actionRestricted();
                            return;
                          }
                          CommonToast({
                            text: "Feature coming soon",
                            icon: ICONS?.INFO,
                            variant: "var(--coming-soon)",
                            buttonNeeded: false,
                          });
                          // openTransactionHistory();
                        }}
                        icon={ICONS?.TRANSACTION_HISTORY}
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary)"}
                        disabledBgColor={"var(--primary-nav-act)"}
                        disabledTextColor={"var(--text-primary)"}
                        hoverOption="white"
                        isDisabled={type === "tax_account_detail_modal"}
                        fullWidthRequired={true}
                      />
                    </div>
                    <div className="settingsm flex flex-row">
                      <TopNavSmallButton
                        btnText={
                          <>
                            {" "}
                            Edit <br /> account
                          </>
                        }
                        handleFunction={() => {
                          const status =
                            taxCompliantDetailsData?.tds_accounts?.[0]
                              ?.approval_status;

                          if (["archived", "blocked"].includes(status)) return;

                          if (type === "tax_account_detail_modal") {
                            actionRestricted();
                            return;
                          }

                          if (
                            services?.some(
                              (service) =>
                                service === "CTDSAccount" ||
                                service === "Admin",
                            )
                          ) {
                            handleModalOpen(id);
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "CTDSAccount",
                              },
                            });
                          }
                        }}
                        icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        hoverOption="white"
                        isDisabled={
                          type === "tax_account_detail_modal" ||
                          ["archived", "blocked"].includes(
                            taxCompliantDetailsData?.tds_accounts?.[0]
                              ?.approval_status,
                          ) ||
                          !services?.some(
                            (service) =>
                              service === "CTDSAccount" || service === "Admin",
                          )
                        }
                        fullWidthRequired={true}
                      />

                      {/* </> */}
                      {/* )} */}
                      <div className="flex">
                        <div className="flex-grow border-l border-solid border-primary-bg"></div>
                      </div>
                      {/* {taxCompliantDetailsData?.tds_accounts[0]
                      .approval_status === "blocked" ||
                    services?.find(
                      (service) =>
                        service === "ArchiveTDSAccount" || service === "Admin",
                    ) === undefined ? (
                      <>
                        <TopNavSmallButton
                          // btnText={label}
                          btnText={"Unarchive/Archive account"}
                          handleFunction={() => {
                            alert("Unarchive/Archive account");
                            // if (
                            //   taxCompliantDetailsData?.tds_accounts[0]
                            //     .approval_status !== "blocked"
                            // ) {
                            //   if (
                            //     services?.find(
                            //       (service) =>
                            //         service === "ArchiveTDSAccount" ||
                            //         service === "Admin",
                            //     ) !== undefined
                            //   ) {
                            //     handleUnarchive();
                            //     handleArchive();
                            //   } else {
                            //     navigate("/feature_not_assigned", {
                            //       state: {
                            //         unavailableService: "ArchiveTDSAccount",
                            //       },
                            //     });
                            //   }
                            // }
                          }}
                          // icon={
                          //   services?.find(
                          //     (service) =>
                          //       service === "ArchiveTDSAccount" ||
                          //       service === "Admin",
                          //   ) === undefined &&
                          //   taxCompliantDetailsData?.tds_accounts[0]
                          //     .approval_status === "archived"
                          //     ? ICONS?.UNARCHIVE
                          //     : ICONS?.ARCHIVE
                          // }
                          icon={
                            ICONS?.ARCHIVE
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary"}
                          hoverOption="white"
                          // isDisabled={
                          //   type === "tax_account_detail_modal" ||
                          //   taxCompliantDetailsData?.tds_accounts[0]
                          //     .approval_status === "blocked"
                          // }
                          fullWidthRequired={true}
                        />
                      </>
                    ) : ( */}
                      <TopNavSmallButton
                        btnText={
                          taxCompliantDetailsData?.tds_accounts?.[0]
                            ?.approval_status === "archived" ? (
                            <>
                              Unarchive <br /> account
                            </>
                          ) : (
                            <>
                              Archive <br /> account
                            </>
                          )
                        }
                        handleFunction={() => {
                          const status =
                            taxCompliantDetailsData?.tds_accounts?.[0]
                              ?.approval_status;

                          const hasPermission = services?.some(
                            (service) =>
                              service === "ArchiveTDSAccount" ||
                              service === "Admin",
                          );

                          if (type === "tax_account_detail_modal") {
                            actionRestricted();
                            return;
                          }

                          if (status === "blocked") return;

                          if (hasPermission) {
                            handleUnarchive();
                            handleArchive();
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ArchiveTDSAccount",
                              },
                            });
                          }
                        }}
                        icon={
                          taxCompliantDetailsData?.tds_accounts?.[0]
                            ?.approval_status === "archived"
                            ? ICONS?.UNARCHIVE
                            : ICONS?.ARCHIVE
                        }
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        hoverOption="white"
                        isDisabled={
                          type === "tax_account_detail_modal" ||
                          taxCompliantDetailsData?.tds_accounts?.[0]
                            ?.approval_status === "blocked" ||
                          !services?.some(
                            (service) => service === "ArchiveTDSAccount",
                          )
                        }
                        fullWidthRequired={true}
                      />
                      {/* )} */}
                    </div>
                  </div>
                </div>
              </div>

              <div className=" bg-primary-card mb-margin-md Qsmd:mb-margin-base">
                {" "}
                <div className="  w-full  lg:w-max-content-width m-auto">
                  {" "}
                  <CommonAlertsStrip alerts={buildAlerts()} />
                </div>
              </div>
              <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto pb-padding-md overflow-x-hidden">
                <div className="detail-category-button w-full ml-margin-md lg:ml-margin-base flex Qmd:pt-padding-md pb-padding-md lg:mx-auto Qmd:mx-margin-md Qlg:mx-margin-base">
                  <div
                    className=" overflow-x-auto"
                    style={{
                      scrollbarWidth: "none",
                    }}
                  >
                    <SwitcherTabs
                      tabs={[
                        {
                          label: "Details",
                          key: "Details",
                          handler: toggleContactDetails,
                        },
                        {
                          label: "Tax details",
                          key: "Tax details",
                          handler: toggleTaxDetails,
                          isDisabled:
                            taxCompliantDetailsData?.tds_accounts?.[0]?.category?.toLowerCase?.() !==
                            "tds",
                        },
                        {
                          label: "Labels",
                          key: "Labels",
                          handler: toggleAssignedLabels,
                        },
                        {
                          label: "Recipients",
                          key: "Recipients",
                          handler: toggleAdditionalRecipicent,
                        },
                      ]}
                      swicherTabBgColor={"var(--primary-card)"}
                      initialActiveTab={
                        showTaxDetails
                          ? "Tax details"
                          : showAssignedLabels
                            ? "Labels"
                            : additionalRecipient
                              ? "Recipients"
                              : ""
                      }
                      setIndex={setIndex}
                    />
                  </div>
                </div>
                {index === GlobalConfiguration?.lengthCheckZero && (
                  <div className={animationClass}>
                    {taxCompliantDetailsData?.tds_accounts?.map((account) => {
                      let originItemList = [
                        {
                          content: account?.contact_no
                            ? `+91 ${account.contact_no}`
                            : "",
                          heading: "Contact number",
                          type: "text",
                        },
                        {
                          content: account?.email_id?.toLowerCase(),
                          heading: "Email ID",
                          type: "text",
                        },
                      ];

                      let AccountItemList = [
                        {
                          content: account?.pan_no,
                          heading: "PAN number",
                          type: "text",

                          onClick: () => {
                            const hasAccess = services?.some(
                              (service) =>
                                service === "VPAN" || service === "Admin",
                            );

                            if (hasAccess && account?.pan_no) {
                              if (type === "tax_account_detail_modal") {
                                actionRestricted();
                              } else {
                                handlePANDetails(account?.pan_no);
                              }
                            } else {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "VPAN" },
                              });
                            }
                          },

                          isDisabled:
                            type === "tax_account_detail_modal"
                              ? true
                              : services?.some(
                                    (service) =>
                                      service === "VPAN" || service === "Admin",
                                  ) &&
                                  account?.pan_no &&
                                  type !== "tax_account_detail_modal"
                                ? false
                                : true,
                        },

                        {
                          content: account?.pan_legal_name
                            ?.toLowerCase()
                            ?.split(" ")
                            ?.map(
                              (word) =>
                                word
                                  .charAt(GlobalConfiguration?.lengthCheckZero)
                                  .toUpperCase() +
                                word.slice(GlobalConfiguration?.lengthCheckOne),
                            )
                            ?.join(" "),
                          heading: "Legal name",
                          type: "text",
                        },
                        {
                          content: account?.gstin_detail
                            ? account?.gstin_detail
                            : "Not Given",
                          heading: "GST number",
                          type: "text",

                          onClick: () => {
                            if (type === "tax_account_detail_modal") {
                              actionRestricted();
                            } else {
                              if (!account?.gstin_detail) return;

                              const hasAccess =
                                services?.includes("VGSTIN") ||
                                services?.includes("Admin");
                              if (hasAccess) {
                                setGstShowPopup(true);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: { unavailableService: "VGSTIN" },
                                });
                              }
                            }
                          },

                          isDisabled:
                            type === "tax_account_detail_modal"
                              ? true
                              : account?.gstin_detail &&
                                  (services?.includes("VGSTIN") ||
                                    services?.includes("Admin"))
                                ? false
                                : true,
                        },
                      ];
                      let originTimelineItemList = [
                        {
                          content:
                            accountNameStandardised(account?.created_by_name) ||
                            "Not given",
                          heading: "Created by",
                          type: "text",
                        },
                        {
                          content: account?.created_on
                            ? formatDateViewAll(account.created_on, true, true)
                            : "Not given",
                          heading: "Created on",
                          type: "text",
                        },

                        // ✅ APPROVED
                        ...(account?.approval_status === "approved"
                          ? [
                              {
                                content:
                                  account?.approved_by_name || "Not given",
                                heading: "Approved by",
                                type: "text",
                              },
                              {
                                content: account?.approved_on
                                  ? formatDateViewAll(
                                      account?.approved_on,
                                      true,
                                      true,
                                    )
                                  : "Not given",
                                heading: "Approved on",
                                type: "text",
                              },
                            ]
                          : []),

                        // ✅ REJECTED
                        ...(account?.approval_status === "rejected"
                          ? [
                              {
                                content:
                                  account?.rejected_by_name || "Not given",
                                heading: "Rejected by",
                                type: "text",
                              },
                              {
                                content: account?.rejected_on
                                  ? formatDateViewAll(
                                      account?.rejected_on,
                                      true,
                                      true,
                                    )
                                  : "Not given",
                                heading: "Rejected on",
                                type: "text",
                              },
                              {
                                content:
                                  account?.rejection_reason || "Not given",
                                heading: "Rejected reason",
                                type: "text",
                              },
                            ]
                          : []),

                        // ✅ ARCHIVED
                        ...(account?.approval_status === "archived"
                          ? [
                              {
                                content:
                                  account?.archived === "Y" &&
                                  !account?.archived_by_name
                                    ? nameArchive
                                    : account?.archived_by_name || "Not given",
                                heading: "Archived by",
                                type: "text",
                              },
                              {
                                content: account?.archived_on
                                  ? formatDateViewAll(
                                      account?.archived_on,
                                      true,
                                      true,
                                    )
                                  : "Not given",
                                heading: "Archived on",
                                type: "text",
                              },
                            ]
                          : []),

                        // ✅ BLOCKED
                        ...(account?.approval_status === "blocked"
                          ? [
                              {
                                content:
                                  account?.blocked_by_name || "Not given",
                                heading: "Blocked by",
                                type: "text",
                              },
                              {
                                content: account?.blocked_on
                                  ? formatDateViewAll(
                                      account?.blocked_on,
                                      true,
                                      true,
                                    )
                                  : "Not given",
                                heading: "Blocked on",
                                type: "text",
                              },
                            ]
                          : []),
                      ];

                      let SupportInformationList = [
                        {
                          content: account?.id,
                          heading: "Tax account ID",
                          type: "text",
                        },
                      ];

                      return (
                        <div
                          className={`flex flex-col lg:flex-row justify-around gap-gap-md mx-margin-md lg:mx-auto`}
                        >
                          <CommonDetailCard
                            cardTitle="Contact Details"
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="fourth"
                            entries={originItemList}
                          />
                          <div
                            className={`flex flex-col lg:flex-row justify-around gap-gap-md lg:mx-auto`}
                          >
                            <CommonDetailCard
                              cardTitle="Account Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={AccountItemList}
                            />

                            <div className="flex flex-col lg:flex-row justify-around lg:mb-margin-xl gap-gap-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originTimelineItemList}
                              />
                            </div>

                            <div className="flex flex-col lg:flex-row justify-around mb-margin-xl gap-gap-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Support Information"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={SupportInformationList}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckOne && (
                  <div className={animationClass}>
                    {taxCompliantDetailsData?.tds_accounts.map((account) => (
                      <CommonDetailCard
                        key={account.id}
                        cardTitle="Section Details"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        variant="fourth"
                        isDisabled={
                          account?.type_of_account?.toLowerCase?.() !== "tds"
                        }
                        entries={[
                          {
                            content:
                              account?.tax_section?.section_name ||
                              "Not available",
                            heading: "Section code",
                            type: "text",
                          },
                          {
                            content:
                              account?.tax_section?.description ||
                              "Not available",
                            heading: "Section description",
                            type: "text",
                          },
                        ]}
                      />
                    ))}
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckTwo && (
                  <div className={animationClass}>
                    <CommonContainerCard
                      header="Assigned Labels"
                      subheader="Labels will be used to generate statistics for the associated accounts."
                      handleFunction={(e) => {
                        e.stopPropagation();
                        if (
                          !services?.includes("ALabel") &&
                          !services?.includes("RLabel")
                        ) {
                          navigate("/feature_not_assigned", {
                            state: { unavailableService: "ALabel,RLabel" },
                          });
                          return;
                        }
                        if (type === "tax_account_detail_modal") {
                          actionRestricted();
                          return;
                        }

                        setShowLabelsPopup(true);
                      }}
                      icon={ICONS?.EDIT}
                      iconIsDisabled={
                        type === "tax_account_detail_modal" ? true : false
                      }
                    >
                      <div className="flex flex-wrap w-full gap-gap-sm">
                        {Array.isArray(labelDetails) &&
                        labelDetails?.length >
                          GlobalConfiguration.lengthCheckZero ? (
                          <>
                            {labelDetails.map((item, index) => (
                              <div
                                key={index}
                                className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                              >
                                <div className="text-text-primary text-font-xs inline-block truncate">
                                  {item}
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <p className="text-font-sm text-text-primary">
                            No labels assigned.
                          </p>
                        )}
                      </div>
                    </CommonContainerCard>
                  </div>
                )}

                {index === GlobalConfiguration?.lengthCheckThree && (
                  <div className={animationClass}>
                    <CommonContainerCard
                      header={TEXT?.ADDITIONAL_RECIPIENTS}
                      subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                      icon={ICONS?.EDIT}
                      handleFunction={(e) => {
                        e.stopPropagation();
                        if (!ensureAll(["CTDSAccount"]).status) {
                          navigate("/feature_not_assigned", {
                            state: { unavailableService: "CTDSAccount" },
                          });
                          return;
                        }
                        if (type === "tax_account_detail_modal") {
                          actionRestricted();
                          return;
                        } else if (
                          taxCompliantDetailsData?.tds_accounts?.[0]
                            .approval_status === "archived" ||
                          taxCompliantDetailsData?.tds_accounts?.[0]
                            .approval_status === "blocked"
                        ) {
                          return;
                        } else {
                          setShowAdditionalSection(true);
                          setAdditionalChip(showAdditionalRecipient);
                        }
                      }}
                      iconIsDisabled={
                        !ensureAll(["CTDSAccount"]).status
                          ? true
                          : type === "tax_account_detail_modal" ||
                              taxCompliantDetailsData?.tds_accounts?.[0]
                                .approval_status === "archived" ||
                              taxCompliantDetailsData?.tds_accounts?.[0]
                                .approval_status === "blocked"
                            ? true
                            : false
                      }
                    >
                      <div className="flex flex-wrap w-full gap-gap-sm">
                        {Array.isArray(showAdditionalRecipient) &&
                        showAdditionalRecipient?.length >
                          GlobalConfiguration.lengthCheckZero ? (
                          <>
                            {showAdditionalRecipient?.map((item, index) => (
                              <div
                                key={index}
                                className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                              >
                                <span className="text-text-primary text-font-xs font-normal truncate">
                                  {linkIdentifier(item)}
                                </span>
                              </div>
                            ))}
                          </>
                        ) : (
                          <span className="text-text-primary text-sm font-normal">
                            {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                          </span>
                        )}
                      </div>
                    </CommonContainerCard>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TaxationAccountDetails;
